import HeaderBar from "@/components/ui/HeaderBar";
import { UI_STYLES } from "@/styles/uiStyles";
import { motion } from "framer-motion";
import SwiperFanSlider from "./ui/SwiperFanSlider";
import { useCardOfTheDayScreenViewModel } from "./CardOfTheDayScreenViewModel";
import CardOfTheDayView from "./ui/CardOfTheDayView";
import ScreenLoader from "@/components/ui/ScreenLoader";
import { Helmet } from "react-helmet-async";

export default function CardOfTheDayScreen() {

  const {
    selectedCard, 
    selectCard,
    navigateToHome,
    timeToNextCard,
    isLoading,
  } = useCardOfTheDayScreenViewModel();

  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{ duration: 0.3, ease: "easeInOut" }}
      className="h-full"
    >
      <Helmet>
        <title>Карта дня Таро | Мир Звёзд</title>
        <meta name="description" content="Ежедневная карта Таро дня с подробным толкованием. Узнайте, что готовит для вас сегодняшний день, получите совет от карт и начните день с мудрости Таро. Новое предсказание каждый день." />
        <meta name="keywords" content="карта дня, таро дня, ежедневное гадание, карты таро, предсказание дня, толкование карт, гадание на картах, астрология, мистика" />
        <meta name="author" content="bpTech" />
        <meta name="robots" content="index, follow" />
        <meta property="og:title" content="Карта дня Таро | Мир Звёзд" />
        <meta property="og:description" content="Ежедневная карта Таро дня с подробным толкованием. Узнайте, что готовит для вас сегодняшний день." />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://мир-звезд.рф/card-of-the-day" />
      </Helmet>
      <ScreenLoader isLoading={isLoading} />
      <div
        className={`flex flex-col relative overflow-x-hidden  h-screen bg-no-repeat bg-center bg-cover ${UI_STYLES.backgroundDarkBlue}`}
      >
        <HeaderBar title="Карта дня" onBack={navigateToHome} />
        <div className="flex flex-col items-center flex-1 w-full max-w-[430px] mx-auto ">
          { selectedCard?.card ? (
            <CardOfTheDayView card={selectedCard} timeToNextCard={timeToNextCard} />
          ) : (
            <div className="w-full max-w-md pt-20 ">
              <SwiperFanSlider onCardClick={selectCard} cardsCount={20}
              />
            </div>
          )}
        </div>
      </div>
    </motion.div>
  );
}
